import { Container, Icon, Link, Text } from "@chakra-ui/react";
import { Link as GatsbyLink } from "gatsby";
import { ReactComponent as ESCDA2026Logo } from "src/assets/icons/ESCDA2026.svg";
import { useIsESCDA2026Enabled } from "src/hooks/useIsESCDA2026Enabled";

const LINK_URL = "/conseillers";

export const ESCDA2026Banner = () => {
  const { isESCDA2026Enabled } = useIsESCDA2026Enabled();

  if (!isESCDA2026Enabled) {
    return null;
  }

  return (
    <Container
      alignItems="center"
      backgroundColor="primary-yellow"
      display={{
        base: "none",
        lg: "flex",
      }}
      gap="space-16"
      justifyContent="center"
      paddingY={12.33}
      width="100%"
    >
      <Icon alt="ESCDA2026" as={ESCDA2026Logo} height="auto" width={25} />

      <Text fontWeight="medium" variant="primary">
        Shine, Élu Service Client de l'Année 2026* dans la catégorie{" "}
        <Text as="i">Banque en ligne</Text> pour entreprises
      </Text>

      <Link
        as={GatsbyLink}
        to={LINK_URL}
        textDecorationLine="underline"
        style={{
          textDecorationSkipInk: "none",
          textUnderlinePosition: "from-font",
        }}
      >
        En savoir plus
      </Link>
    </Container>
  );
};
